import { createAction } from "redux-actions";

// Update product link
export const REQUESTED_UPDATE_PRODUCT_LINK = "REQUESTED_UPDATE_PRODUCT_LINK";
export const RECEIVED_UPDATE_PRODUCT_LINK = "RECEIVED_UPDATE_PRODUCT_LINK";

export const requestUpdateProductLink = createAction(
  REQUESTED_UPDATE_PRODUCT_LINK
);
export const receiveUpdateProductLink = createAction(
  RECEIVED_UPDATE_PRODUCT_LINK,
  (productGroups) => ({ productGroups })
);
